/**
 * @generated SignedSource<<7dbcc19a2a2ba1f7ec8288eb3683786a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarPillsLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarPills_item">;
  readonly " $fragmentType": "PdpRespSidebarPillsLazy_item";
};
export type PdpRespSidebarPillsLazy_item$key = {
  readonly " $data"?: PdpRespSidebarPillsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarPillsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarPillsLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarPills_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "05dfc764eadb696ebc7c57010571e6d2";

export default node;
